export default "__VITE_ASSET__Cbw0wb0E__"